import {ProgressIndicator} from '@/components-v2/molecules/ProgressIndicator/ProgressIndicator'
import {Button} from '@/components-v2/atoms/Button/Button'
import {HeaderTitle, Modal} from '@/components/atoms'
import {usePromotion} from '@/context/Promotion/PromotionContext'
import {PromotionStep} from '@/types/promotion'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {Header} from '@/utils/constants/header'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {PromotionFooter} from './PromotionFooter'
import {PromotionStepContent} from './PromotionStep'
import {promotionProgressLevelSteps} from '@/utils/promotions/promotionConstants'

export const CreatePromotion = () => {
  const {promotion, handleDraft, currentStep, setCurrentStep, handleUpdatePromotion, cleanupBannerImage} = usePromotion()
  const navigate = useNavigate()

  const [showCancelModal, setShowCancelModal] = useState(false)
  const [isDraftLoading, setIsDraftLoading] = useState(false)

  const handleNextAction = async () => {
    if (currentStep === PromotionStep.REVIEW) {
      handleUpdatePromotion({isCreating: true})
      return
    }

    if (currentStep === PromotionStep.SETUP && !promotion.id) {
      // Save a draft first to get promotion ID required for image upload.
      try {
        setIsDraftLoading(true)
        await handleDraft({isSavingForImageUpload: true})
        setCurrentStep(currentStep + 1)
      } catch {
        // Keep user on current step when draft save fails.
      } finally {
        setIsDraftLoading(false)
      }
      return
    }

    setCurrentStep(currentStep + 1)
  }

  const handleCancel = async () => {
    if (currentStep === PromotionStep.DISPLAY) {
      await cleanupBannerImage()
    }
    navigate(ROUTES.PROMOTIONS_LIST)
  }

  const handleBack = () => {
    if (currentStep === PromotionStep.SETUP) {
      navigate(ROUTES.PROMOTIONS_LIST)
      return
    }

    setCurrentStep(currentStep - 1)
  }

  return (
    <div className="flex flex-col gap-4">
      <Button text="Back" variant="tertiary" iconLeading="arrow_back_ios" onClick={handleBack} />
      <HeaderTitle title={'Create Promotion'} headingLevel={Header.PageHeader} className="$font-heading-h3-bold" />
      <ProgressIndicator currentStep={currentStep} steps={4} titles={promotionProgressLevelSteps} className="p-6" />

      <PromotionStepContent step={currentStep} promotion={promotion} setCurrentStep={setCurrentStep} />

      {showCancelModal && (
        <Modal
          type={MODAL_TYPE.SMALL}
          showModal={showCancelModal}
          onCloseModal={() => setShowCancelModal(false)}
          title="Are you sure you want to cancel?"
          text={'The changes will not be saved.'}
          showPrimaryButton={true}
          primaryButtonText="Yes"
          onClickPrimaryButton={handleCancel}
          showSecondaryButton={true}
          secondaryButtonText="No"
          onClickSecondaryButton={() => setShowCancelModal(false)}
          footerProps={{
            size: 'medium',
            type: 'primary',
          }}
          isDark={true}
        />
      )}

      <PromotionFooter
        currentStep={currentStep}
        onCancel={() => setShowCancelModal(true)}
        onNext={handleNextAction}
        isLoading={isDraftLoading}
      />
    </div>
  )
}
